export default __webpack_public_path__ + "media/baec2c4a99bf5a1ddb628ddac80ba8fb-ludwig.jpg";